export const ICON_COLORS = {
  alertSupDefault: "#26A4AB",
  alertInfDefault: "#FFA726",
  white: "#FFF",
  black: "#192A3E"
}